import { BrowserRouter, Route, Routes } from "react-router-dom";
import "@/App.css";
import Dashboard from "@/pages/Dashboard";
import AdminLogin from "@/pages/AdminLogin";
import AdminPanel from "@/pages/AdminPanel";
import PublicReport from "@/pages/PublicReport";
import TvMode from "@/pages/TvMode";
import PrintReport from "@/pages/PrintReport";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Dashboard />} />
        <Route path="/login" element={<AdminLogin />} />
        <Route path="/admin" element={<AdminPanel />} />
        <Route path="/laporan/:slug" element={<PublicReport />} />
        <Route path="/tv" element={<TvMode />} />
        <Route path="/cetak" element={<PrintReport />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
